import React from 'react';

const Loader = () => {
  return (
    <>
      <div className='si-loader__wrap'>
        <img className='si-loader--img' src={require('assets/images/loader.gif')} alt='loader' />
      </div>
    </>
  );
};

export default Loader;
